import * as types from './types'

export default {
  [types.SET_CRITERIA_CHANGED](state, value) {
    state.criteriaChanged = value
  },
  [types.SET_STEP](state, data) {
    state.step = data
  },
  [types.SET_VISITED_STEP](state, currentStep) {
    state.visitedStep = currentStep > state.visitedStep
      ? currentStep
      : state.visitedStep
  },
  [types.RESET_VISITED_STEP](state, data) {
    state.visitedStep = data
  },
  [types.RESET_RECOMMENDATION](state) {
    state.recommendation = JSON.parse(JSON.stringify(state.newRecommendation))
  },
  [types.PREP_RECOMMENDATION](state, firm) {
    state.recommendation.firm = firm
    state.recommendation.testDriveRecommendation = null
  },
  [types.UPDATE_RECOMMENDATION](state, data) {
    if (state.recommendation !== null && data !== null) {
      switch (data.name) {
        case 'firm':
          state.recommendation.firm = parseInt(data.value)
          break
        case 'vehicleMake':
          state.recommendation.vehicleMake = parseInt(data.value)
          break
        case 'driveType':
          state.recommendation.driveType = parseInt(data.value)
          break
        case 'recommendation':
          state.recommendation.recommendation = data.value
          break
        case 'recommendationText':
          state.recommendation.recommendationText = data.value
          break
      }
    }
  },
  [types.SET_RECOMMENDATIONS](state, data) {
    state.recommendations = data
  },
  [types.SET_RECOMMENDATION](state, data) {
    state.recommendation = data
  },
  [types.RESET_TRANSLATIONS](state, data) {
    state.translations = []
  },
  [types.SET_TRANSLATIONS](state, data) {
    state.translations = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.translations = data
      }
    }
  },
  [types.RESET_RESULTTYPE](state) {
    state.testdriveResultType = JSON.parse(JSON.stringify(state.newResultType))
  },
  [types.SET_RESULTTYPES](state, data) {
    state.testdriveResultTypes = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.testdriveResultTypes = data
      }
    }
  },
  [types.SET_RESULTTYPE](state, data) {
    state.testdriveResultType = JSON.parse(JSON.stringify(state.newResultType))
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.testdriveResultType = data[0]
      }
    }
  },
  [types.UPDATE_RESULTTYPE](state, data) {
    if (state.testdriveResultType !== null && data !== null) {
      switch (data.name) {
        case 'firm':
          state.testdriveResultType.firm = parseInt(data.value)
          break
        case 'year':
          if (data.value === null || data.value === '') {
            state.testdriveResultType.year = null
          } else {
            state.testdriveResultType.year = parseInt(data.value)
          }
          break
        case 'vehicleMake':
          if (data.value === null || data.value === '') {
            state.testdriveResultType.vehicleMake = null
          } else {
            state.testdriveResultType.vehicleMake = parseInt(data.value)
          }
          break
        case 'driveType':
          if (data.value === null || data.value === '') {
            state.testdriveResultType.driveType = null
          } else {
            state.testdriveResultType.driveType = parseInt(data.value)
          }
          break
        case 'testdriveResultTypeName':
          state.testdriveResultType.testdriveResultTypeName = data.value
          break
        case 'testdriveResultCode':
          state.testdriveResultType.testdriveResultCode = data.value
          break
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/configuration/mutations.js